import { useMemo } from 'react';

/**
 * Returns true if the user prefers reduced motion, false otherwise.
 */
export function usePrefersReducedMotion(): boolean {
	return useMemo(() => {
		if (typeof window !== 'undefined' && window.matchMedia) {
			return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
		}
		return false;
	}, []);
}
